export enum PagesNames {
  Login = 'login',
  Register = 'register',
  Companies = 'companies',
  Users = 'users',
  NeoAnalytics = 'neoAnalytics',
  Procedures = 'procedures',
  Collaboration = 'collaboration',
  Licenses = 'licenses',
  Download = 'download',
  Analytics = 'analytics',
  Profile = 'profile',
  Groups = 'groups',
}
